import { Badge } from 'twyne-new.ui';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function StatusFormatter({ info }) {
  const { value } = getInfo(info)

  return <Badge variant='outline' color={value ? 'accent' : 'success'}>
    {value ? 'active' : 'finished'}
  </Badge>
}
